import React from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components'

const InnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: 0  ${props => props.bigmode ? "0" : "10px"};;
    /* max-width: 1800px; */
    padding-left: ${props => props.bigmode ? "0" : "100px"};
    flex-grow: 1;

    @media (max-width: 1000px) or (max-height: 660px) {
        padding-left: ${props => props.bigmode ? "0" : "10px"};
    }

    img {
        width: 200px;
        padding-right: 50px;

        @media (max-width: 1250px) {
            width: 150px;
            padding-right: 10px;
            margin-top: 4px;
        }

        /*next breakpoint should be 1000px*/
    }

    form {
        position: relative;
        
        input {
            width: 100%;
            border: 0;
            padding: ${props => props.bigmode ? "0" : "18px 0"};
            margin: 0;
            outline: none;
            background-color: transparent;
            font-size: ${props => props.bigmode ? "55px" : "22px"};
            font-weight: 600;

            ::placeholder {
                color: blue;
            }

            @media (max-width: 1000px) {
                font-size: ${props => props.bigmode ? "25px" : "22px"};
            }
        }

        img {
            width: ${props => props.bigmode ? "40px" : "25px"};
            padding: 0;
            margin: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            @media (max-width: 1000px) {
                width: 25px;
            }

            display: none;
        }

        img.clear_field_cross {

            width: ${props => props.bigmode ? "35px" : "25px"};
            @media (max-width: 1000px) {
                width: 20px;
            }

            display: ${props => props.searchFieldContent ? 'block' : 'none'};
            /* right: ${props => props.bigmode ? "60px" : "50px"}; */
            left: ${props => props.searchFieldContentWidth + 10}px;
            cursor: pointer;

            /* @media (max-width: 1000px) {
                right: ${props => props.bigmode ? "40px" : "50px"};
            } */
        }

        img.loupe-mobile {
            /* display: none;

            @media (max-width: 1000px) { */
                display: block;
                /* right: ${props => props.bigmode ? "0" : "10px"}; */
                left: ${props => props.searchFieldContentWidth + (props.bigmode ? 55 : 45)}px;

                @media (max-width: 1000px) {
                    left: ${props => props.searchFieldContentWidth + (props.bigmode ? 40 : 38)}px;
                }
                /* left: unset; */
                /* pointer-events: all; */
                cursor: pointer;
            /* } */
        }
    }
`

const Searchbar = (props) => {

    const {i18n} = useTranslation('common');

    const navigate = useNavigate();
    const [searchFieldContent, setSearchFieldContent] = React.useState(props.searchFieldContent || '');
    const [searchFieldFocused, setSearchFieldFocused] = React.useState(false);
    const [searchFieldContentWidth, setSearchFieldContentWidth] = React.useState(0);
    const inputRef = React.useRef(null);

    const onSearch = (event) => {
        event.preventDefault();
        const search = searchFieldContent;
        if(props.onsearch) {
            props.onsearch(search);
            return;
        }
        navigate('/annuaire?q=' + search);
    }

    const clearField = () => {
        setSearchFieldContent('');

        //clear the input field
        if(inputRef.current) {
            inputRef.current.value = '';
        }

        if(props.onsearch) {
            props.onsearch('');
            return;
        }
    }

    React.useEffect(() => {
        if(searchFieldContent) {
            //get the length of the search field content in pixels in order to place the cross and loupe at the right place
            const input = inputRef.current;
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            context.font = getComputedStyle(input).font;
            setSearchFieldContentWidth(context.measureText(searchFieldContent).width);
        }
    }, [searchFieldContent])

    return (
        <InnerContainer lang={i18n.language} searchFieldContent={searchFieldContent} searchFieldContentWidth={searchFieldContentWidth} bigmode={props.bigmode}>
            <form onSubmit={onSearch} style={{width:'100%'}}>
                <input
                    defaultValue={props.searchFieldContent}
                    ref={inputRef}
                    onChange={e => setSearchFieldContent(e.target.value)}
                    onFocus={() => setSearchFieldFocused(true)}
                    onBlur={() => setSearchFieldFocused(false)}
                    style={{width:'100%'}}
                    placeholder={searchFieldFocused ? '' : i18n.language === "fr" ? "Rechercher" : "Search"}
                />
                {/* <img src='/img/loupe_bleue.png' alt='search'/> */}
                {searchFieldContent && <img onClick={clearField} className='clear_field_cross' src='/img/x_bleu_grand.png' alt=""/>}
                {searchFieldContent && <img onClick={onSearch} className='loupe-mobile' src='/img/loupe_bleue.png' alt='search'/>}
            </form>
        </InnerContainer>
    );
};

export default Searchbar;